module.exports = __webpack_public_path__ + "img/symbol_19.c531c004.png";